import { Box, Button } from '@mui/material'
import React, {useRef} from 'react'
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import CancelIcon from '@mui/icons-material/Cancel';

const Upload = ({ files, setFiles }) => {
    const uploadRef = useRef();

    const handleDragEnter = (e) => {
        e.preventDefault();
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDrop = (e) => {
        e.preventDefault();
        filesHandler(e.dataTransfer.files);

    };

    const filesHandler = (newFiles) => {
        const tempFiles = Array.from(newFiles);
        setFiles(prev => [...tempFiles]);
    }

    const removeFiles = (index) => {
        setFiles(prev => prev.filter((e, i) => i !== index));
    }

    const clickHandler = () => {
        uploadRef.current.focus();
    }
    return (
        <Box
            className="uploadContainer"
            sx={{
                display: 'grid',
                gridTemplateColumns: files?.length ? "50% 50%" : '1fr',
                height: '100%',
                gap: '10px',
                flexDirection: 'column',
                justifyContent: 'center'
            }}
        >
            <Button
                size='small'
                onClick={clickHandler}
                className={`uploadButton`}
                sx={{
                    width:files?.length ? '100%' : '75%',
                    height:files?.length ? '100%' : '100%'
                }}
                onDragEnter={handleDragEnter}
                onDragLeave={handleDragLeave}
                onDragOver={handleDragOver}
                onDrop={handleDrop}
            >
                <input multiple onClick={(e)=>e.target.value = null} onChange={(e) => filesHandler(e?.target?.files)} ref={uploadRef} type='file' />
                <Box sx={{ position: 'absolute', textAlign: 'center', display: 'grid', justifyContent: 'center' }}>
                    <DriveFolderUploadIcon onClick={clickHandler} sx={{ margin: 'auto' }} fontSize='large' color='rgb(180, 179, 179)' />
                    <span onClick={clickHandler}>Click to Upload Files or Drag Files Here</span>
                </Box>
            </Button>
            {/* <Divider orientation='vertical' sx={{margin:'0 .3rem'}} ></Divider> */}
            {files?.length ? <Box sx={{ width: '98%', borderLeft: '1px dotted grey', padding: '0 .3rem' }}>
                <Box style={{ textAlign: 'center', width: '100%', fontSize: '18px',marginBottom:'.3rem' }}>Uploaded Files</Box>
                <div style={{ display: 'flex', gap: '5px', flexWrap: 'wrap', padding: '.3rem 0',justifyContent:'center' }}>

                    {
                        files?.length ? files.map((e, index) => {
                            return <Button size='small' variant='contained' style={{ backgroundColor: "grey" }} key={`files-${index}`} endIcon={<CancelIcon onClick={() => { removeFiles(index) }} />}>{e.name}</Button>
                        }) : <span className='noFiles'>No Files Selected</span>
                    }
                </div>
            </Box> : ''}
        </Box>
    )
}

export default Upload
